/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('modal.show', function (e) {
        if (e.options.classes.includes('location-modal')) {
            var mapDiv = e.modal.element.firstElementChild;
            e.modal.element.style.width = '700px';
            var options = JSON.parse(mapDiv.dataset.mapOptions);
            moya.map.createMapFromSelector('#customWrapId', options);
            moya.map.osmMap.setZoom(options.zoom);
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
